import { HttpClient } from '@angular/common/http';
import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { EMPTY, Observable, shareReplay } from 'rxjs';
import { environment } from '../../../environments/environment';
import { RelatorioResponse } from './models/relatorio.models';

@Injectable({ providedIn: 'root' })
export class RelatorioService {
  private readonly http = inject(HttpClient);
  private readonly isBrowser = isPlatformBrowser(inject(PLATFORM_ID));
  private readonly url = `${environment.apiUrl}/relatorio`;

  private cache?: Observable<RelatorioResponse[]>;

  /** Lista de publicações do EvEx (compartilhada/cacheada). */
  getRelatorios(): Observable<RelatorioResponse[]> {
    // No SSR/prerender não há backend acessível via `/api`.
    if (!this.isBrowser) return EMPTY;
    if (!this.cache) {
      this.cache = this.http
        .get<RelatorioResponse[]>(this.url)
        .pipe(shareReplay(1));
    }
    return this.cache;
  }
}
